module.exports = __webpack_public_path__ + "static/media/bideyisheng.20a94fa0.mp3";